
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-4-09 (1.0.0) (jhoward)
 *    - Copy from ValentinesDay_defaultSection.vue component to Easter_defaultSection.vue component.
 */

import {defineComponent, PropType} from "vue";
import { ALLOWED_ITEM_COMPONENTS, Menu, MenuSection } from "../defs";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";

export default defineComponent({
  components: {
    DefaultVisualSection, DefaultTextualSection,
  },
  name: "Easter_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menuVersion: {
      type: String,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menu: {
      type: Object as PropType<Menu | null>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
  mounted() {
    this.section.ms_title = this.sectionTitle();
    this.section.ms_subtitle = this.sectionSubtitle();
  },
  data: function () {
    return {};
  },
  methods: {
    sectionTitle(): string {
      const output = this.section.ms_title;
      if ('easter dining menu' === output.toLowerCase()) {
        return 'EASTER DINING';

      }
      if (output.length) {
        return output.replace(/-/g, '<span class="menu--title_hyphen">-</span>');
      }

      return 'DINING';
    },
    sectionSubtitle(): string {
      if (this.section.ms_subtitle.length) {
        return this.section.ms_subtitle.replace(/-/g, '<span class="menu--title_hyphen">-</span>');
      }

      return (this.menu?.page?.page_h1 || '').toUpperCase();
    },
  }
})
